import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Prestations from "@/pages/Prestations";
import Stages from "@/pages/Stages";
import Audio from "@/pages/Audio";
import MentionsLegales from "@/pages/MentionsLegales";
import Mediatheque from "@/pages/Mediatheque";
import Actualites from "@/pages/Actualites";
import Association from "@/pages/Association";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminForgot from "@/pages/admin/AdminForgot";
import AdminReset from "@/pages/admin/AdminReset";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SiteProvider>
        <HelmetProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/prestations" element={<Prestations />} />
              <Route path="/stages" element={<Stages />} />
              <Route path="/galerie" element={<Mediatheque />} />
              <Route path="/audio" element={<Audio />} />
              <Route path="/mediatheque" element={<Navigate to="/galerie" replace />} />
              <Route path="/actualites" element={<Actualites />} />
              <Route path="/association" element={<Association />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
            </Route>
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/mot-de-passe-oublie" element={<AdminForgot />} />
            <Route path="/admin/reinitialiser" element={<AdminReset />} />
            <Route path="/admin/tableau" element={<AdminDashboard />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
        </HelmetProvider>
        </SiteProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
